import { createSlice } from "@reduxjs/toolkit";

const UserSlice = createSlice({
  name: "user",
  initialState: {
    initialData: {},
    userData: {},
    callId: "",
    token: "",
    error: "",
    language: {},
  },
  //flag:true,
  reducers: {
    addInitialData: {
      reducer(state, action) {
        state.initialData = action.payload;
      },
    },
    addToUser: {
      reducer(state, action) {
        state.userData = action.payload;
      },
    },
    addToken: {
      reducer(state, action) {
        state.token = action.payload;
      },
    },
    addError: {
      reducer(state, action) {
        state.error = action.payload;
      },
    },
    addLanguage: {
      reducer(state, action) {
        state.language = action.payload;
      },
    },
    addCallId: {
      reducer(state, action) {
        state.callId = action.payload;
      },
    },
  },
});

export const {
  addInitialData,
  addToUser,
  addToken,
  addError,
  addLanguage,
  addCallId,
} = UserSlice.actions;

export default UserSlice.reducer;

export const getToken = (state) => state.user.token;
export const getUserData = (state) => state.user.userData;
export const getInitialData = (state) => state.user.initialData;
export const getError = (state) => state.error;
export const getLanguageContent = (state) => state.user.language;
export const getCallId = (state) => state.user.callId;
